import { Injectable } from '@angular/core';
import {SysFunction} from "../model/sys/SysFunction";
import {HttpClient} from "@angular/common/http";
import {StorageService} from './storage.service';
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PermissionToolkitService {
  functionData: SysFunction[] = [];
  privilegeList: any[] = [];
  functionMaps = {};
  http;
  storageService;
  constructor(
    http: HttpClient,
    storageService: StorageService
  ) {
    this.http = http;
    this.storageService = storageService;
    const cachedFunctionData = storageService.getLocalItem('cachedFunctionData');
    if (cachedFunctionData) {
      this.functionData = cachedFunctionData;
    }
    const cachedPrivilegeData = storageService.getLocalItem('cachedPrivilegeData');
    if (cachedPrivilegeData) {
      this.privilegeList = cachedPrivilegeData;
    }
  }

  init(uriToGetAllFunctionData: string): Observable<any> {
    return this.http.get(uriToGetAllFunctionData).pipe(map(res => {
      if (res['code'] === 0) {
        this.setFunctionData(res['data']);
      }
      return res;
    }));
  }

  setFunctionData(data: SysFunction[]) {
    this.storageService.setLocalItem('cachedFunctionData', data);
    this.functionData = data;
  }

  setUserPrivilegeList(data: any[]) {
    this.storageService.setLocalItem('cachedPrivilegeData', data);
    this.privilegeList = data;
  }

  getUserPrivilegeList() {
    return this.storageService.getLocalItem('cachedPrivilegeData');
  }

  getFunctionMaps() {
    this.functionMaps = {};
    if (this.functionData) {
      this.functionData.forEach(f => {
        this.functionMaps[f['id']] = {code: f.functionCode}
      });
    }
    return this.functionMaps
  }

  public getModulePages(moduleFunction) {
    let result = [];
    if (this.functionData && moduleFunction) {
      const childrenNodes = this.functionData.filter(f => moduleFunction.id === f.parentId);
      result = childrenNodes;
    }
  }

  clearData() {
    this.functionData.forEach(f => f.processedUrl = null);
  }

  hasPrivilegePermission(privilegeCode: string, nodeData: string | SysFunction) {
    let node;
    if (typeof nodeData === 'string') {
      node = this.functionData.find(f => f.functionCode === nodeData);
    } else {
      node = nodeData;
    }

    if (this.functionData && node) {
      const childrenNodes = this.functionData.filter(f => node.id === f.parentId);
      const targetNode = childrenNodes.find(f => f.functionType === 'PRIVILEGE' && f.functionCode === privilegeCode);
      if (targetNode) {
        if (this.privilegeList.includes(targetNode.id)) {
          return true;
        } else {
          return false;
        }
      } else {
        let result = false;
        for (let i = 0; i < childrenNodes.length; i++) {
          result = this.hasPrivilegePermission(privilegeCode, childrenNodes[i]);
          if (result === true) {
            break;
          }
        }
        return result;
      }
    } else {
      return false;
    }
  }

  getChildrenPages(nodeData: string | SysFunction): SysFunction {
    let node;
    const privilegeList = this.getUserPrivilegeList();
    const functionData = this.functionData.filter(f => privilegeList.includes(f.id) && f['displayed']);
    if (typeof nodeData === 'string') {
      node = functionData.find(f => f.functionCode === nodeData);
    } else {
      node = nodeData;
    }

    if (functionData && node) {
      const childrenNodes = functionData.filter(f => node.id === f.parentId && f.functionType === 'PAGE');
      childrenNodes.forEach(cn => {
        if (!cn.processedUrl) {
          cn.processedUrl = cn.functionUri;
        } else {
          cn.processedUrl = node.functionUri + cn.functionUri;
        }
        this.getChildrenPages(cn);
      });
      if (!node.processedUrl) {
        node.processedUrl = node.functionUri;
      }
      node.childFunctions = childrenNodes;
      return node;
    } else {
      return null;
    }
  }

  public getAvailableSubSystem() {
    return this.getAvailableFunctions(['SUBSYS']);
  }

  public getAvailableModules() {
    return this.getAvailableFunctions(['MODU']);
  }

  getFunctionData() {
    return this.storageService.getLocalItem('cachedFunctionData');
  }
  getPrivilegeList() {
    return this.storageService.getLocalItem('cachedPrivilegeData');
  }

  public getAvailableFunctions(functionTypes: string[]) {
    const functionData = this.getFunctionData();
    const privilegeList = this.getPrivilegeList();
    if (functionData && privilegeList) {
      const functionIds = functionData.filter(f => functionTypes.includes(f.functionType )).map(f => f.id);
      const intersection = functionIds.filter(v => privilegeList.includes(v));
      if (intersection.length > 0) {
        return functionData.filter(f => intersection.includes(f.id));
      }
    }
  }

  hasPagePermission(code) {
    let hasPermission = true;
    const functionMap = this.getFunctionMaps();
    // const privilegeList = this.storageService.getItem('privilegeList');
    const privilegeList = this.privilegeList;
    if (code) {
      if (functionMap && privilegeList) {
        const availFunctions = [];
        privilegeList.forEach(p => {
          const sysFunction = functionMap[p];
          if (sysFunction) {
            availFunctions.push(sysFunction);
          }
        });
        const currentFunction = availFunctions.find(f => f.code === code);
        if (currentFunction) {
          hasPermission = true;
        } else {
          hasPermission = false;
        }
      } else {
        hasPermission = false;
      }
    } else {
      hasPermission = false;
    }
    return hasPermission;
  }
}
